import type Paginated from 'app/core/paginable';
import Env from 'env';
import i18next from 'i18next';
import queryString from 'query-string';
import { buildParams } from 'utils/params';

import { notification } from '../core/notifications/notification';

import { headers, HttpAxios, promiseWith } from './httpAxios';

export class HttpApiApplication extends HttpAxios {
  constructor() {
    super({ baseURL: Env.baseUrlApplicationApi, headers: headers });
  }

  async paginate<T = any, R = Paginated<T>>(
    baseUrl: string,
    page: number,
    pageSize: number,
    params: any = undefined,
    includeLang?: boolean
  ): Promise<R> {
    const newParams = buildParams(params);
    const header = includeLang ? { headers: { lang: true } } : {};
    const queryParams = newParams ? `&${queryString.stringify(newParams)}` : '';
    const response = await this.service.get(
      `${baseUrl}?page=${page}&pageSize=${pageSize}${queryParams}`,
      header
    );
    return promiseWith<R>(response.data);
  }

  async download(baseUrl: string, filename: string, params: any = undefined) {
    const newParams = buildParams(params);
    const queryParams = newParams ? `&${queryString.stringify(newParams)}` : '';
    const response = await this.service.get(`${baseUrl}?${queryParams}`, {
      responseType: 'blob',
      headers: { lang: true }
    });
    if (response.data?.size > 0) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
    } else {
      notification.warning(i18next.t('common.messages.nofileContent'));
    }
  }
}
export default new HttpApiApplication();
